/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `info` - Info
 * * `low` - Low
 * * `medium` - Medium
 * * `high` - High
 * * `critical` - Critical
 * @export
 */
export const FindingSeverityEnum = {
    Info: 'info',
    Low: 'low',
    Medium: 'medium',
    High: 'high',
    Critical: 'critical'
} as const;
export type FindingSeverityEnum = typeof FindingSeverityEnum[keyof typeof FindingSeverityEnum];


export function instanceOfFindingSeverityEnum(value: any): boolean {
    for (const key in FindingSeverityEnum) {
        if (Object.prototype.hasOwnProperty.call(FindingSeverityEnum, key)) {
            if (FindingSeverityEnum[key as keyof typeof FindingSeverityEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FindingSeverityEnumFromJSON(json: any): FindingSeverityEnum {
    return FindingSeverityEnumFromJSONTyped(json, false);
}

export function FindingSeverityEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindingSeverityEnum {
    return json as FindingSeverityEnum;
}

export function FindingSeverityEnumToJSON(value?: FindingSeverityEnum | null): any {
    return value as any;
}

export function FindingSeverityEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): FindingSeverityEnum {
    return value as FindingSeverityEnum;
}

